import React from 'react';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';
import { Bar } from 'react-chartjs-2';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

export type BarChartSet = {
  label: string;
  data: { x: string | number; y: string | number }[];
  backgroundColor: string;
};

export interface BarChartProps {
  data: BarChartSet | BarChartSet[];
}

const BarChart: React.FC<BarChartProps> = ({ data }) => {
  const dataArray = React.useMemo(() => {
    return Array.isArray(data) ? data : [data];
  }, [data]);

  const labels = React.useMemo(() => {
    return dataArray
      .flatMap((set) => set.data.map((d) => d.x))
      .reduce<any>((res, a) => {
        if (!res.includes(a)) {
          res.push(a);
        }
        return res;
      }, []);
  }, [dataArray]);

  const datasets = React.useMemo(() => {
    return dataArray.map((set) => ({
      ...set,
      data: set.data.map((d) => d.y),
    }));
  }, [dataArray]);

  return (
    <Bar
      options={{
        responsive: true,
        plugins: {
          legend: {
            position: 'top' as const,
          },
          title: {
            display: false,
          },
        },
      }}
      data={{
        labels,
        datasets,
      }}
    />
  );
};

export default BarChart;
